const state = {
  cardNo: '',
  startTime: '',
  endTime: '',
  list: []
}

const mutations = {
  SET_ECARDNO(state, obj) {
    state.cardNo = obj.cardNo
  },
  SET_List(state, obj) {
    state.list = obj.list
  },
  SET_TIME(state, obj) {
    state.startTime = obj.startTime
    state.endTime = obj.endTime
  },
  RESET(state) {
    state.cardNo = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
